import {connect} from 'react-redux'
import {adProductSelector, productDocumentFilesSelector} from 'data/redux/selectors/productSelector';
import {
  getLoadFileDownload, getLoadFileThumbnail,
  getLoadInitialFiles
} from 'data/redux/actions/documentsActions';
import FileInput from 'gui/components/formikFileInput/components/fileInput/FileInput';

const noFilesSelected = value => {
  if (value && Array.isArray(value)) {
    return value.length === 0;
  }
  return true;
};

const mapStateToProps = (state, {field, form}) => {
  const product = adProductSelector(state);
  if (product && product.id && noFilesSelected(field.value)) {
    const initialFiles = productDocumentFilesSelector(state);
    return {
      product,
      initialFiles
    };
  }
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadFileImage: (file_id) => dispatch(getLoadFileThumbnail(file_id)),
    downloadFile: (file_id) => dispatch(getLoadFileDownload(file_id)),
    loadInitialFiles: (product_id) => dispatch(getLoadInitialFiles(product_id)),
  };
};

const EditorDocumentInputContainer = connect(mapStateToProps, mapDispatchToProps)(FileInput);

export default EditorDocumentInputContainer;
